import moment from "moment";
export const AddDaysToTimestamp = (days, date) => {
  const d = new moment(date.toDate());
  return new moment(d).add(days(), "days").toDate();
};
